import { Updatable } from "../..";


export abstract class ApplicationSettings extends Updatable {
    abstract get isValid(): boolean;
}
